import { forwardRef } from 'react';

import { cn } from '../../utils';

import { SwitchClassNames } from './constants';
import { InputElement, LabelText, SwitchRoot } from './Switch.styled';
import SwitchPills from './SwitchPills';
import { SwitchProps } from './types';

const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, inputRef) => {
  const {
    isColored = false,
    checked,
    dataOff,
    dataOn,
    className,
    label,
    isLabelHidden,
    elementSize = 'big',
    disabled = false,
    ...rest
  } = props;

  return (
    <SwitchRoot
      aria-label={label}
      className={cn(SwitchClassNames.Root, className)}>
      <LabelText
        $elementSize={elementSize}
        $isHidden={isLabelHidden}
        className={SwitchClassNames.Label}>
        {label}
      </LabelText>
      <InputElement
        ref={inputRef}
        {...rest}
        checked={checked}
        disabled={disabled}
        type="checkbox"
      />

      <SwitchPills
        checked={checked}
        dataOff={dataOff}
        dataOn={dataOn}
        disabled={disabled}
        elementSize={elementSize}
        isColored={isColored}
      />
    </SwitchRoot>
  );
});

Switch.displayName = 'Switch';

export default Switch;
